module.exports = __webpack_public_path__ + "img/ledsquare.750056f2.jpg";